
import { useState } from 'react';

import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import Button from 'src/onboarding/components/ui/button/Button';

import { Title } from 'src/onboarding/components/typography/Title/Title';
import { MultiCheck } from 'src/onboarding/components/ui/multi-check/MultiCheck';
import { MultiOption } from 'src/onboarding/components/ui/multi-check/Option';

import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const activityPlan = useStore((state) => state.activityPlan);
  const setActivityPlan = useStore((state) => state.setActivityPlan);
  const [next, setNext] = useState(activityPlan.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setActivityPlan(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.activityPlan.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={activityPlan} onChange={handleChange}>
          <MultiOption value={'Try new types of physical activity'}>
            <span>🧪</span> {t('onboarding.activityPlan.options.activity')}
          </MultiOption>
          <MultiOption value={'Reach a daily step goal'}>
            <span>🚶</span> {t('onboarding.activityPlan.options.goal')}
          </MultiOption>
          <MultiOption value={'Choose walking instead of driving'}>
            <span>🚴</span> {t('onboarding.activityPlan.options.walking')}
          </MultiOption>
          <MultiOption value={'Add a new workout type'}>
            <span>🏋️</span> {t('onboarding.activityPlan.options.new')}
          </MultiOption>
          <MultiOption value={'Set dedicated time for workouts'}>
            <span>⏰</span> {t('onboarding.activityPlan.options.time')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.activityPlan.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'activity-plan',
              answer: activityPlan.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
